// extracted by mini-css-extract-plugin
module.exports = {"container":"_1EedU","isTop":"TmzJE","withPagination":"_3rOE5","innerContainer":"_1qy_x","pagination":"_3d06f","arrow":"_3uVDQ","page":"_4oQkI","active":"f1SKi"};